import React from "react"
import strings from "../../../../localization/strings"
import { IPunchException, IDate } from "../../../../models"
import * as timeHelper from "../../../../helpers/timeHelper"
import moment from "moment"

interface IProps {
	style: React.CSSProperties
	hierarchyId: string
	jobId: string
	exception: IPunchException
}
interface IState {
	reviwedDateTime: IDate
}
export default class ExceptionReviewedInfo extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			reviwedDateTime: null
		}
	}

	componentDidMount() {
		this.getReviwedDateTime(this.props)
	}

	componentWillReceiveProps(nextProps: IProps) {
		if (this.props.exception.Id !== nextProps.exception.Id || this.props.exception.ReviewedDateTime !== nextProps.exception.ReviewedDateTime)
			this.getReviwedDateTime(nextProps)
	}

	async getReviwedDateTime(props: IProps) {
		let reviwedDateTime = timeHelper.convertDefaultDateToNull(props.exception.ReviewedDateTime)
		if (!reviwedDateTime)
			return

		reviwedDateTime = await timeHelper.getDateTime(props.hierarchyId, props.jobId, props.exception.ReviewedDateTime)
		this.setState({ reviwedDateTime })
	}

	render() {
		if (!this.props.exception.ReviewedUserName || !this.state.reviwedDateTime) return null
		return (
			<div style={this.props.style}>
				<span>
					{strings.formatString(this.props.exception.Approved ? strings.Approved_by_on : strings.Rejected_by_on, this.props.exception.ReviewedUserName, moment(this.state.reviwedDateTime).format("llll"))}
				</span>
			</div>
		)
	}
}